/// *** System import ***///
import { Component, Injectable, Inject } from '@angular/core';
import { IonicPage, Nav, MenuController, Platform, Events, NavController, NavParams, Content, ViewController, ModalController, PopoverController, AlertController, ToastController, LoadingController } from 'ionic-angular';
/// *** Custom import ***///
import { Globals } from '../../app/globals';
import { EnvVariables } from '../../app/environment-variables/environment-variables.token';
import { SessionProvider } from '../../providers/session';
/// *** Page import ***///
import { Market_SessionPage } from '../market/session/session';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  private credentials: any = {
    login: null,
    password: null
  };
  private connectionError = false;
  private connectionMsg: string;
  constructor(
    // *** System
    private nav: NavController,
    private platform: Platform,
    private sideMenu: MenuController,
    private events: Events,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    @Inject(EnvVariables) private envVariables,
    private session: SessionProvider) {
    this._initSession();
  }

  // *** Initialisation de la session
  private _initSession() {
    try {
      let loader = this.loadingController.create({
        dismissOnPageChange: true,
        content: this.globals.MSG_INIT,
      });
      loader.present();
      this.session.load().then(
        (succeed) => {
          this.session.validate().then(
            (succeed) => { this.nav.setRoot(Market_SessionPage); },
            (error) => { loader.dismiss(); }
          );
        },
        (error) => { loader.dismiss(); });
    }
    catch (error) { this.globals.showUnknownError(this.toastCtrl, error); }
  }

  // *** Evénement de chargement
  ionViewDidLoad() {
    this.sideMenu.swipeEnable(false);
  }

  // *** Evénement de clôture
  ionViewWillUnload() {
    this.sideMenu.swipeEnable(true);
  }

  /// *** Se connecter
  private _login() {
    try {
      let loader = this.loadingController.create({
        dismissOnPageChange: true,
        content: this.globals.MSG_CONNECTION,
      });
      loader.present();
      this.connectionMsg = null;
      this.connectionError = false;
      this.session.login(this.credentials).then(
        (succeed) => { this.nav.setRoot(Market_SessionPage); },
        (error) => {
          this.connectionMsg = error;
          this.connectionError = true;
          loader.dismiss();
        }
      );
    }
    catch (error) {
      this.connectionError = false;
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  /// *** Mot de passe oublié
  private _forgotPassword() {
    // *** ToDo
  }
}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts